import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ro from "../locales/ro.json";
import en from "../locales/en.json";
import fr from "../locales/fr.json";
import de from "../locales/de.json";
import it from "../locales/it.json";
import es from "../locales/es.json";
import pt from "../locales/pt.json";
import ptBR from "../locales/pt-BR.json";
import sr from "../locales/sr.json";

/** Languages we ship. Order here drives the LanguageSwitcher dropdown. */
export const SUPPORTED_LANGUAGES = [
  { code: "ro", name: "Română", flag: "🇷🇴" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "pt", name: "Português", flag: "🇵🇹" },
  { code: "pt-BR", name: "Português (Brasil)", flag: "🇧🇷" },
  { code: "sr", name: "Srpski", flag: "🇷🇸" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ro: { translation: ro },
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      it: { translation: it },
      es: { translation: es },
      pt: { translation: pt },
      "pt-BR": { translation: ptBR },
      sr: { translation: sr },
    },
    fallbackLng: { "pt-BR": ["pt", "en"], default: ["en"] },
    nonExplicitSupportedLngs: false,
    load: "currentOnly",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "sc_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
